<template>
    <div>
        <Header title="即将到期">
        </Header>
        
        <div class="my-white-mod">
            <div style="margin-bottom:10px">
                <Input prefix="ios-search" v-model="search_name" placeholder="请输入用户姓名、群号" style="width:240px;"></Input>
                <TagScreen @changeTags="changeTag" @changeTagsId="changeTagId" ></TagScreen>
                <DatePicker type="daterange" placement="bottom-end" placeholder="选择订单成交时间" style="width: 200px;margin-left:10px"  @on-change="change_success_date"></DatePicker> 
            </div>
            <div>
                <DatePicker type="daterange" placement="bottom-end" placeholder="选择订单到期时间" style="width: 200px;"  @on-change="change_expiration_date"></DatePicker> 
                <Select style="width:187px;margin-left:10px" placeholder="请选择" v-model="search_status"   >
                    <Option v-for="item in status_all" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                <Button type="warning" @click="searchList" style="margin-left:10px">搜索</Button>
                <Button  @click="ok_export" type="success" style="margin-left:10px">导出</Button>

            </div>
        </div>
        <div class="my-white-mod">
            <PageTable :loading="table.loading"  :columns="table.columns" :data="table.data" :size="table.limit"  :current="table.current" :total="table.total"  @switchPage="changepage" >
            </PageTable>
        </div>



        <Modal
                :mask-closable="false"
                v-model="show_success"
                title="续费"
                width="650">
                <!-- <DealShow :department_member_list="department_member_list" :transaction_list="transaction_list" :successSubmit="successSubmit"></DealShow> -->
                
                <!-- <div slot="footer">
                    <Button  type="primary"  @click="success_order">确定</Button >
                </div> -->
                <div class="modal-title">成交金额</div>
                <Input  placeholder="请填写成交金额" v-model="successSubmit.money"  />
                <div class="modal-title modal-title-two">服务费</div>
                <Input  placeholder="请填写服务费用，作为下次收费参考" v-model="successSubmit.servicecharge"  />
                <div class="modal-title-two">完整单号</div>
                <Input  placeholder="请填写完整单号" v-model="successSubmit.order_number"  />
                <div class="modal-title modal-title-two">成交方式</div>
                <Select placeholder="请选择成交方式" v-model="successSubmit.transaction_type_id" filterable >
                    <Option v-for="item in transaction_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                
                <div class="modal-title modal-title-two">成交时间</div>
                <DatePicker style="width:187px"  type="datetime" v-model="successSubmit.pay_time" placeholder="选择成交时间" @on-change="changeSuccessDate"></DatePicker>
              
                <div class="modal-title modal-title-two">售后人员</div>
                <Select placeholder="请选择售后人员"  v-model="successSubmit.aftersale_id" clearable  filterable >
                    <Option v-for="item in department_member_list" :value="item.id" :key="item.id">{{ item.platform_name }}-{{ item.name }}</Option>
                </Select>
                <span style="font-size:10px;color:red">不选择售后则默认为不需要售后，订单直接进入完结状态</span>
                <span v-if="!successSubmit.aftersale_id">
                    <div class="modal-title modal-title-two">到期类型</div>
                    <RadioGroup v-model="successSubmit.duesoon_type">
                        <Radio label="1" border>选择到期时间</Radio>
                        <Radio label="2" border>永久有效</Radio>
                    </RadioGroup>
                </span>
                <span v-if="!successSubmit.aftersale_id && successSubmit.duesoon_type == 1">
                    <div class="modal-title modal-title-two">到期时间</div>
                    <DatePicker type="date" placeholder="选择日期" style="width: 200px" @on-change="changeDate"></DatePicker>
                </span>

                <div class="modal-title modal-title-two">服务要求</div>
                <Input  placeholder="请填写服务要求：系统类型 公众认证情况 是否需要申请支付功能" type="textarea" v-model="successSubmit.service_requirements" />
                <div slot="footer">
                    <Button  type="primary"  @click="success_order">确定</Button >
                </div>
        </Modal>
        <Modal
                v-model="show_no_renew"
                title="不续费的原因"
                :mask-closable="false"
                width="400"
        >
            <Input placeholder="请填写不续费的原因" v-model="renewSubmit.no_renew_reason" type="textarea"  />
            <div slot="footer">
                <Button  type="primary"  @click="ok_no_renew">确定</Button >
            </div>
        </Modal>
        <Tags :customer_id="customer_id" :show_tags="show_label" :tags_active="tags_active" :is_return="tags_return" @return_data="get_select_tags" @hide_lable="hide_label_func"></Tags>
    </div>

</template>
<script>
import {get_transaction,customer_department_member} from "@/api/customer"
import {expire_order, renew_order, noRenewOrder, export_expire_order} from "@/api/order"
import {Header, PageTable, TagScreen, Tags, DealShow} from "@/components/mainLayout"
import {copyText, getCurrentDate} from "@/utils/helper";
import moment from "moment"
export default {
    components:{
    Header,
    PageTable,
    TagScreen,
    Tags,
    DealShow
},
    data(){
        return{
            customer_id:0,
            show_label:false,
            tags_return:false,
            tags_active:[],
            search_name:"",
            show_success:false,
            transaction_list:[],
            department_member_list:[],
            successSubmit:{},
            show_no_renew:false,
            current_date:getCurrentDate(),
            search_status:0,
            renewSubmit:{
                id:0,
                no_renew_reason:""
            },
            status_all:[
                {
                    id:0,
                    name:"所有"
                },{
                    id:1,
                    name:"待续费"
                },{
                    id:2,
                    name:"不续费"
                }
            ],
            screen_tags_text:"",
            screen_tags_id:"",
            table:{
                loading:false,
                current:1,
                total:0,
                columns: [
                    {
                        title: '单号',
                        width:'120',
                        align:'center',
                        key: 'id'
                    },
                    {
                        title: '群号',
                        width:'120',
                        align:'center',
                        key: 'qq_group'
                    },
                    {
                        title: '客户',
                        align:'center',
                        key: 'name',
                        width:300,
                        render: (h, params) => {
                            let male = require("../../assets/11.png");
                            let female = require("../../assets/12.png");
                            let default_img = require("../../assets/3.png");
                            if (params.row.avatar != null && params.row.avatar != "") {
                                default_img = params.row.avatar
                            }
                            let default_ = female;
                            if (params.row.gender == 1) {
                                default_ = male;
                            }
                            if (params.row.is_big == 1) {
                                var default_big = require("@/assets/is_big.png");
                            }
                            return h("div", {
                                domProps:{
                                    innerHTML:`<div style="display: flex;padding:10px 0 5px;height: 100px;cursor:pointer">`+
                                        `<img src=`+default_img+` style="width:50px;height:50px;">` +
                                        `<div style="margin-left:10px;flex:1;text-align: left;">` +
                                            `<div>`+(params.row.remark || params.row.customer_name)+`</div>`+
                                            `<div><img src=`+default_+` style="width:20px;height:20px;"><img src=`+default_big+` style="width:32px;height:10.5px;">`+`</div>`+
                                        `</div>` +
                                        `</div>`
                                },
                                on:{
                                    click:()=>{
                                        copyText(params.row.remark || params.row.customer_name)
                                    }
                                }
                            })

                        }
                    },
                    {
                        title: '标签',
                        align:'center',
                        key: 'id',
                        width:300,
                        render: (h,params) => {
                            let tpl = "", tag_name = params.row.tag_name;
                            if (tag_name && tag_name.length > 0) {
                                for(let i in tag_name) {
                                    tpl += `<div><div  class="tag-class">`+tag_name[i]+`</div></div>`;
                                }
                            } else {
                                tpl += `<div class="tag-dotted">尚未设置</div>`;
                            }
                            return h("div", {
                                domProps:{
                                    innerHTML:`<div style="display:flex;flex-wrap:wrap;padding:10px 0 5px">`+
                                        tpl +
                                        `</div>`
                                },
                                on: {
                                    click: () => {
                                        this.customer_id = params.row.customerId;
                                        this.tags_active = params.row.tags_active;
                                        this.tags_return = false;
                                        this.show_label = true
                                    }
                                }
                            })

                        }
                    },
                    {
                        title: '跟进员工',
                        align:'center',
                        width:200,
                        key: 'id',
                        render: (h, params) => {
                            let department_member_name = params.row.department_member_name ? params.row.department_member_name : "暂无"
                            return h('div', [
                                h('span', {
                                    style:{color:'#445E87'}
                                }, department_member_name)
                            ]);

                        }
                    },
                    {
                        title: '到期时间',
                        align:'center',
                        width:150,
                        key: 'ctime',
                        render: (h, params) => {
                            let text = "", textcolor = "";
                            if (params.row.diff_date > 30 ) {
                                text = params.row.expiration_date;
                                textcolor = "#445E87";
                            } else if(params.row.diff_date == "无有效") {
                                text = "永久有效";
                                textcolor = "#445E87";
                            } else  {
                                text = params.row.diff_date+"天";
                                textcolor = "#ff0000";
                            }
                            return h('div', [
                                h('span', {
                                    style:{color:textcolor}
                                },text)
                            ]);

                        }
                    },
                    {
                        title: '成交时间',
                        align:'center',
                        width:170,
                        key: 'pay_time',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style:{color:'#445E87'}
                                }, params.row.pay_time.replace("T", " "))
                            ]);
                        }
                    },{
                            title: '不续费原因',
                            align:'center',
                            width:'200',
                            key: 'renew_reason',
                            render: (h, params) => {
                                return h('Input',{
                                    props: {
                                        value:params.row.renew_reason,
                                        type:'textarea'
                                    }
                                })
                            }
                        },
                    {
                        title: '操作',
                        align:'center',
                        key: 'id',
                        fixed: 'right',
                        width:140,
                        render: (h, params) => {
                            let renew_btn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#3F8CFF'},
                                on: {
                                    click: () => {
                                        this.successSubmit = {
                                            duesoon_type:'1',
                                            qq_group:"",
                                            money:"",
                                            order_id:"",
                                            pay_time:this.current_date,
                                            order_number:'',
                                            transaction_type_id:"",
                                            aftersale_id:"",
                                            service_requirements:"",
                                            expiration_date:"",
                                            servicecharge:"",
                                            name:params.row.customer_name,  
                                            remark:params.row.remark,
                                            phone:params.row.phone,
                                            wechat_number:params.row.wechat_number,
                                            wangwang_number:params.row.wangwang_number,
                                            city_number:params.row.city_number,
                                            city_name:params.row.city_name,
                                            detailed_address:params.row.detailed_address
                                        }
                                        this.successSubmit.id = params.row.id;
                                        this.show_success = true;
                                    }
                                }
                            }, '续费');
                            let no_renew_btn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#ff0000'},
                                on: {
                                    click: () => {
                                        this.show_no_renew = true
                                        this.renewSubmit.id = params.row.id;
                                    }
                                }
                            }, '不续费');
                            let infos_btn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#3F8CFF'},
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            path: '/customerpool/info',
                                            query: {
                                                order_id: params.row.id,
                                                customer_id:params.row.customerId,
                                                type:1
                                            }
                                        });
                                    }
                                }
                            }, '详情');
                            let btn_arr = []
                            if (params.row.is_renew ==0) {
                                btn_arr.push(renew_btn)
                                btn_arr.push(no_renew_btn)
                            }
                            btn_arr.push(infos_btn)
                            return h('div', btn_arr);

                        }

                    }
                ],
                data: []
            },
            success_start_date:"",
            success_end_date:""

        }
    },
    mounted(){
        this.getList();
        this.get_transaction_list();
        this.get_customer_department_member();
    },
    methods:{
        
        changeDate(e){
                this.successSubmit.expiration_date = e;
            },
        changeSuccessDate(e){
                this.successSubmit.pay_time = e;
        },
        ok_no_renew(){
            if (this.renewSubmit.no_renew_reason == undefined || this.renewSubmit.no_renew_reason == "") {
                this.$Message.error("请填写不续费的原因");return
            }
            noRenewOrder(this.renewSubmit).then(res=>{
                if(res.code ==200) {
                    this.$Message.success(res.msg);
                    this.getList();
                    this.show_no_renew = false
                } else {
                    this.$Message.error(res.msg);
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        change_success_date(e){
            this.success_start_date = e[0]
            this.success_end_date = e[1]
        },
        change_expiration_date(e){
            this.expiration_start_date = e[0]
            this.expiration_end_date = e[1]
        },
        searchList(){
            this.table.current = 1
            this.getList();
        },
        getList(){

            let val = {limit:this.table.limit, page:this.table.current};
            if(this.search_name != "") {
                val.search_name = this.search_name
            }
            if(this.search_status != "") {
                val.search_status = this.search_status
            }
            if(this.success_start_date != "") {
                val.success_start_date = this.success_start_date
            }
            if(this.success_end_date != "") {
                val.success_end_date = this.success_end_date
            }

            if(this.expiration_start_date != "") {
                val.expiration_start_date = this.expiration_start_date
            }
            if(this.expiration_end_date != "") {
                val.expiration_end_date = this.expiration_end_date
            }

            // if (this.screen_tags_text != "")  {
            //     val.screen_tags_text = this.screen_tags_text
            // }
            if (this.screen_tags_id != "")  {
                val.screen_tags_id = this.screen_tags_id
            }
            this.table.loading = true;
            expire_order(val).then(res=>{
                this.table.loading = false;
                if (res.code == 200) {
                    this.table.data = res.data
                    this.table.total = res.total
                } else {
                    this.table.data = []
                    this.table.total = 0
                    this.$Message.error(res.msg)
                }
            })
        },
        ok_export(){
            if (this.commit == 1) {
                return
            }
            let val = {limit:this.table.limit, page:this.table.current};
            if(this.search_name != "") {
                val.search_name = this.search_name
            }
            if(this.search_status != "") {
                val.search_status = this.search_status
            }
            if(this.success_start_date != "") {
                val.success_start_date = this.success_start_date
            }
            if(this.success_end_date != "") {
                val.success_end_date = this.success_end_date
            }

            if(this.expiration_start_date != "") {
                val.expiration_start_date = this.expiration_start_date
            }
            if(this.expiration_end_date != "") {
                val.expiration_end_date = this.expiration_end_date
            }

            // if (this.screen_tags_text != "")  {
            //     val.screen_tags_text = this.screen_tags_text
            // }
            if (this.screen_tags_id != "")  {
                val.screen_tags_id = this.screen_tags_id
            }
            this.$Message.info({
                content: '处理数据中，请等待',
                duration: 0
            });
            this.commit = 1;
            let _this = this
            export_expire_order(val).then(res=>{
                setTimeout(function(){
                    _this.commit = 0;
                }, 500)
                this.$Message.destroy()
                if(res.code == 200) {
                    let url = res.data
                    if (navigator.userAgent.indexOf("Safari") > -1) {
                        const newPage = window.open("newPage", "_blank");
                        newPage.location = url;
                    } else {
                        window.open(url, "_blank").location;
                    }
                } else {
                    this.$Message.error(res.msg);
                }
            }).catch(err=>{
                setTimeout(function(){
                    _this.commit = 0;
                }, 500)
            })
        },
        changeTag(e){
              this.screen_tags_text = e;
        },
        changeTagId(e){
            this.screen_tags_id = e;
        },
        changepage(e){
            this.table.current = e;
            this.getList();
        },

        // 获取部门员工
        get_customer_department_member(){
            customer_department_member().then(res=>{
                if(res.code == 200) {
                    this.department_member_list = res.data
                } else {
                    this.department_member_list = [];
                }
            })
        },
        get_transaction_list(){
            get_transaction().then(res=>{
                if(res.code == 200) {
                    this.transaction_list = res.data
                } else {
                    this.transaction_list = []
                }
            })
        },
        success_order(){
            if(this.is_submit == 1) {
                return
            }
            this.is_submit = 1;
            if(this.successSubmit.money == "" || isNaN(this.successSubmit.money)) {
                    this.is_submit = 0;
                    this.$Message.error("请正确填写成交金额");return
            }
            
            if(this.successSubmit.servicecharge === "" || isNaN(this.successSubmit.servicecharge)) {
                this.is_submit = 0;
                this.$Message.error("请正确填写服务费");return
            }
            if ( this.successSubmit.transaction_type_id == "" || this.successSubmit.transaction_type_id == null) {
                this.is_submit = 0;
                this.$Message.error("请选择成交方式");return;
            }
            if ( this.successSubmit.pay_time == "" || this.successSubmit.pay_time == null) {
                this.is_submit = 0;
                this.$Message.error("请选择成交时间");return;
            }
            // if ( this.successSubmit.order_number == "" || this.successSubmit.order_number == null) {
            //     this.is_submit = 0;
            //     this.$Message.error("请填写完整单号");return;
            // }
                
            
            this.successSubmit.money = this.successSubmit.money == ""? 0 : this.successSubmit.money;
            this.successSubmit.pay_time = moment(this.successSubmit.pay_time).format('YYYY-MM-DD HH:mm:ss');
            // this.$refs.deal_child.zdyFrom();
            renew_order(this.successSubmit).then(res=>{
                this.is_submit = 0;
                if (res.code == 200) {
                    this.$Message.success(res.msg)
                    this.table.current = 1;
                    this.show_success = false;
                    this.getList();
                } else {
                    this.$Message.error(res.msg)
                }
            }).catch(err=>{
                this.is_submit = 0;
            })
        },
        
        get_select_tags(e){
            this.show_label = false;
            this.screen_tags_list = e;
            this.screen_tags_active = ""
            this.screen_tags_text = ""
            if (this.screen_tags_list) {
                this.tags_active = [];
                let screen_tags = [];
                for(let i in this.screen_tags_list) {
                    this.tags_active.push(this.screen_tags_list[i].tag_id+"，"+this.screen_tags_list[i].tag_name)
                    screen_tags.push(this.screen_tags_list[i].tag_name)
                }
                this.screen_tags_active = this.tags_active
                this.screen_tags_text = screen_tags.join(",")
            }
        },
        hide_label_func(e){
            this.show_label = false
            if (e == 1) {
                this.getList()
            }
        },
    }
}
</script>
<style scoped>

    >>>.tag-class{
        width: 90%;
        padding:5px 10px;
        border:1px solid #ddd;
        border-radius: 5px;
        margin:2px 5px;
        background: #ffffff;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        cursor: pointer;
    }
    >>>.ivu-modal .ivu-picker-panel-body-wrapper .ivu-picker-confirm  .ivu-btn-text{
        display:unset!important
    }
</style>